import { AddSquareIcon, LogoMark, ShareIcon } from './icons';
import styles from './InstallHelp.module.css';

/** The two-tap iOS instruction: Share → "Add to Home Screen". */
export function IosInstallSteps() {
  const safari = !/CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);
  return (
    <ol className={styles.steps}>
      <li className={styles.step}>
        <span className={styles.num}>1</span>
        <div className={styles.text}>
          <span>
            Tap <strong>Share</strong> {safari ? "in Safari's toolbar" : 'in the browser toolbar'}
          </span>
          <span className={styles.hint}>On newer iPhones it's inside the ⋯ menu.</span>
        </div>
        <span className={styles.glyph}>
          <ShareIcon size={26} />
        </span>
      </li>
      <li className={styles.step}>
        <span className={styles.num}>2</span>
        <div className={styles.text}>
          <span>
            Choose <strong>Add to Home Screen</strong>
          </span>
          <span className={styles.sheetRow}>
            <span>Add to Home Screen</span>
            <AddSquareIcon size={20} />
          </span>
        </div>
      </li>
      <li className={styles.step}>
        <span className={styles.num}>3</span>
        <div className={styles.text}>
          <span>
            Open <strong>Bolt Circles</strong> from your Home Screen
          </span>
        </div>
        <span className={styles.appIcon}>
          <LogoMark size={34} />
        </span>
      </li>
    </ol>
  );
}
